<template>
    <div class="">
        <label :for="id" class="block text-sm font-medium text-gray-700">{{ label }} <span v-if="required">*</span></label>
        <div class="mt-1">
            <textarea
                :id="id"
                :name="name"
                :rows="rows"
                :required="required"
                :disabled="disabled"
                :class="textareaClass"
                v-bind:value="modelValue"
                v-on:input="$emit('update:modelValue', $event.target.value)"
                v-on:focus="$emit('focus')"
            ></textarea>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    label: String,
    name: String,
    id: String,
    modelValue: String,
    tabindex: Number,
    rows: {
        type: Number,
        default: 4,
    },
    required: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    error: {
        type: Boolean,
        default: false,
    },
});

defineEmits(['focus', 'update:modelValue']);

const textareaClass = computed(() => {
    return {
        "py-3 px-4 block w-full shadow-sm focus:ring-primary-500 focus:border-primary-500 border rounded-md": true,
        "border-gray-300": !props.error,
        "border-red-500": props.error,
    };
});
</script>
